export interface PDFExportConfig {
  enabled: boolean;
  format: 'A4' | 'letter';
  orientation: 'portrait' | 'landscape';
  margins: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
  includeCover: boolean;
  includeBackCover: boolean;
  includeHeader: boolean;
  includeFooter: boolean;
  includePageNumbers: boolean;
  quality: number;
}

export const defaultPDFExportConfig: PDFExportConfig = {
  enabled: true,
  format: 'A4',
  orientation: 'portrait',
  margins: {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20,
  },
  includeCover: true,
  includeBackCover: true,
  includeHeader: true,
  includeFooter: true,
  includePageNumbers: false,
  quality: 2,
};

// Re-export for convenience
export type { PDFExportConfig as PDFExportSettings };
export { defaultPDFExportConfig as defaultPDFExportSettings };

/**
 * Futura função de exportação PDF.
 * Receberá o templateConfig e a proposta, gerará o PDF.
 */
export async function exportProposalToPDF(
  _templateConfig: unknown,
  _proposal: unknown,
  _config?: PDFExportConfig
): Promise<Blob> {
  // Placeholder: será implementado na fase de PDF Premium
  throw new Error('PDF export not yet implemented. This is a placeholder for future development.');
}